const siteConfig = Object.freeze({
  brandName: "bretailpebble",
  logoText: "bretailpebble",
  logo: Object.freeze({
    type: "wordmark",
    text: "bretailpebble",
    image: null,
    alt: "bretailpebble home",
  }),
  tagline: "Comfortable knitwear for thoughtful everyday dressing.",
  description:
    "Practical knitwear and everyday layers selected by our Hong Kong team for comfort, versatility and lasting wear.",
  locale: "en-HK",
  language: "en",
  currency: "USD",
  currencySymbol: "$",
  country: "HK",
  siteUrl: "",
  contact: Object.freeze({
    email: "limit@bretailpebble.store",
    address: "Hong Kong",
    customerCareHours: "Monday–Friday, 10:00–18:00 HKT",
  }),
  announcement: "Worldwide standard delivery for $9.99",
  shippingThreshold: 0,
  shipping: Object.freeze({
    standardRate: 9.99,
    expressRate: 19.99,
    freeShippingThreshold: 0,
    dispatchTime: "1–3 working days",
    returnsWindowDays: 30,
  }),
  navigation: Object.freeze([
    { label: "Shop", href: "/shop" },
    { label: "New", href: "/shop?filter=new" },
    { label: "Women", href: "/shop?collection=women" },
    { label: "Men", href: "/shop?collection=men" },
    { label: "Kids", href: "/shop?collection=kids" },
    { label: "Accessories", href: "/shop?collection=accessories" },
    { label: "About", href: "/about" },
  ]),
  moreNavigation: Object.freeze([
    { label: "Privacy", href: "/privacy" },
    { label: "Cookies", href: "/cookies" },
    { label: "FAQs", href: "/faqs" },
    { label: "Terms", href: "/terms" },
  ]),
  collections: Object.freeze([
    { id: "women", label: "Women" },
    { id: "men", label: "Men" },
    { id: "kids", label: "Kids" },
    { id: "accessories", label: "Accessories" },
  ]),
  footerNavigation: Object.freeze([
    {
      title: "Shop",
      links: [
        { label: "New arrivals", href: "/shop?filter=new" },
        { label: "Women", href: "/shop?collection=women" },
        { label: "Men", href: "/shop?collection=men" },
        { label: "Kids", href: "/shop?collection=kids" },
        { label: "Accessories", href: "/shop?collection=accessories" },
      ],
    },
    {
      title: "Help",
      links: [
        { label: "Contact", href: "/contact" },
        { label: "FAQs", href: "/faqs" },
        { label: "Shipping", href: "/shipping" },
        { label: "Returns", href: "/returns" },
        { label: "Privacy", href: "/privacy" },
        { label: "Cookies", href: "/cookies" },
        { label: "Terms", href: "/terms" },
      ],
    },
    {
      title: "About",
      links: [
        { label: "Our story", href: "/about" },
        { label: "Materials", href: "/about#materials" },
        { label: "Care guide", href: "/about#care" },
      ],
    },
  ]),
  social: Object.freeze([]),
  seo: Object.freeze({
    defaultTitle: "bretailpebble — everyday knitwear and accessories",
    titleTemplate: "%s — bretailpebble",
    defaultDescription:
      "Comfortable knitwear and accessories selected in Hong Kong.",
    themeColor: "#f1eee7",
  }),
  company: Object.freeze({
    legalName: "bretailpebble",
    vatCountry: "Hong Kong",
  }),
});
export const {
  brandName,
  logoText,
  currency,
  locale,
  contact,
  navigation,
  shippingThreshold,
} = siteConfig;
export default siteConfig;
